import { NgModule } from '@angular/core';
import { TextHighlightPipe } from './text-highlight.pipe';


@NgModule({
    imports: [],
    exports: [TextHighlightPipe],
    declarations: [TextHighlightPipe],
    providers: [],
})
export class TextHighlightPipeModule { }
